import React, { useEffect, useState, useRef } from "react";
import "./BrandComparison.scss";

import cardImg from '../../../assets/images/Frame 14.png'
import SimplePieChart from './SimplePieChart'
import nvidiaImg from '../../../assets/images/nvidia 1.png'
import CardChart from './CardChart'
import axios from 'axios'
// import ourBrand from "./ourBrand.json"
// import competitorsBrand from "./competitorsBrand.json"
// import scoring from "./scoring.json"
import { Icon } from '@iconify/react'
import { Modal } from 'react-bootstrap';
import { Radar } from 'react-chartjs-2';
import 'chart.js/auto';
import { auth, firestoredb } from "../../../config";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { toast } from "react-toastify";
import { useReactToPrint } from 'react-to-print';



const BrandComparison = (props) => {
    const [showComparing, setShowComparing] = useState(false)
    const [loading, setLoading] = useState(false);

    const handleShowComparing = () => {
        setShowComparing(true)
    }
    const [ourBrand, setOurBrand] = useState({});
    const [competitorsBrand, setCompetitorsBrand] = useState({});
    const [scoring, setScoring] = useState("");
    const [done, setDone] = useState(false);
    const reportRef = useRef();

    const handlePrint = useReactToPrint({
        content: () => reportRef.current,
    });
    const user = auth.currentUser

    const dataOurBrand = {
        labels: ['Product', 'CX', 'Commercialization', 'Brand', 'Marketing'],
        datasets: [
            {
                label: `${ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation ? ourBrand.mainAnalysis.brandInformation.brandName : "Your Brand"}`,
                data: [scoring && scoring.ourBrand && scoring.ourBrand.productAnalysis && scoring.ourBrand.productAnalysis.score, scoring && scoring.ourBrand && scoring.ourBrand.cxAnalysis && scoring.ourBrand.cxAnalysis.score, scoring && scoring.ourBrand && scoring.ourBrand.commercializationAnalysis && scoring.ourBrand.commercializationAnalysis.score, scoring && scoring.ourBrand && scoring.ourBrand.brandAttribute && scoring.ourBrand.brandAttribute.score, scoring && scoring.ourBrand && scoring.ourBrand.marketingAnalysis && scoring.ourBrand.marketingAnalysis.score],
                fill: true,
                backgroundColor: 'rgba(54, 162, 235, 0.2)',
                borderColor: 'rgb(54, 162, 235)',
                pointBackgroundColor: 'rgb(54, 162, 235)',
                pointBorderColor: '#fff',
                pointHoverBackgroundColor: '#fff',
                pointHoverBorderColor: 'rgb(54, 162, 235)'
            },
            // {
            //     label: 'My Second Dataset',
            //     data: [28, 48, 40, 19, 96, 27, 100],
            // fill: true,
            // backgroundColor: 'rgba(54, 162, 235, 0.2)',
            // borderColor: 'rgb(54, 162, 235)',
            // pointBackgroundColor: 'rgb(54, 162, 235)',
            // pointBorderColor: '#fff',
            // pointHoverBackgroundColor: '#fff',
            // pointHoverBorderColor: 'rgb(54, 162, 235)'
            // }
        ]
    };

    const data = {
        labels: ['Product', 'CX', 'Commercialization', 'Brand', 'Marketing'],
        datasets: [
            {
                label: `${competitorsBrand.mainAnalysis && competitorsBrand.mainAnalysis.brandInformation ? competitorsBrand.mainAnalysis.brandInformation.brandName : "Your Brand"}`,
                data: [scoring && scoring.competitorBrand && scoring.competitorBrand.productAnalysis && scoring.competitorBrand.productAnalysis.score, scoring && scoring.competitorBrand && scoring.competitorBrand.cxAnalysis && scoring.competitorBrand.cxAnalysis.score, scoring && scoring.competitorBrand && scoring.competitorBrand.commercializationAnalysis && scoring.competitorBrand.commercializationAnalysis.score, scoring && scoring.competitorBrand && scoring.competitorBrand.brandAttribute && scoring.competitorBrand.brandAttribute.score, scoring && scoring.competitorBrand && scoring.competitorBrand.marketingAnalysis && scoring.competitorBrand.marketingAnalysis.score],
                fill: true,
                backgroundColor: 'rgba(255, 99, 132, 0.2)',
                borderColor: 'rgb(255, 99, 132)',
                pointBackgroundColor: 'rgb(255, 99, 132)',
                pointBorderColor: '#fff',
                pointHoverBackgroundColor: '#fff',
                pointHoverBorderColor: 'rgb(255, 99, 132)'
            },
            // {
            //     label: 'My Second Dataset',
            //     data: [28, 48, 40, 19, 96, 27, 100],
            //     fill: true,
            //     backgroundColor: 'rgba(54, 162, 235, 0.2)',
            //     borderColor: 'rgb(54, 162, 235)',
            //     pointBackgroundColor: 'rgb(54, 162, 235)',
            //     pointBorderColor: '#fff',
            //     pointHoverBackgroundColor: '#fff',
            //     pointHoverBorderColor: 'rgb(54, 162, 235)'
            // }
        ]
    };

    const dataCombined = {
        labels: ['Product', 'CX', 'Commercialization', 'Brand', 'Marketing'],
        datasets: [
            {
                label: `${ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation ? ourBrand.mainAnalysis.brandInformation.brandName : "Your Brand"}`,
                data: [scoring && scoring.ourBrand && scoring.ourBrand.productAnalysis && scoring.ourBrand.productAnalysis.score, scoring && scoring.ourBrand && scoring.ourBrand.cxAnalysis && scoring.ourBrand.cxAnalysis.score, scoring && scoring.ourBrand && scoring.ourBrand.commercializationAnalysis && scoring.ourBrand.commercializationAnalysis.score, scoring && scoring.ourBrand && scoring.ourBrand.brandAttribute && scoring.ourBrand.brandAttribute.score, scoring && scoring.ourBrand && scoring.ourBrand.marketingAnalysis && scoring.ourBrand.marketingAnalysis.score],
                fill: true,
                backgroundColor: 'rgba(54, 162, 235, 0.2)',
                borderColor: 'rgb(54, 162, 235)',
                pointBackgroundColor: 'rgb(54, 162, 235)',
                pointBorderColor: '#fff',
                pointHoverBackgroundColor: '#fff',
                pointHoverBorderColor: 'rgb(54, 162, 235)'
            },
            {
                label: `${competitorsBrand.mainAnalysis && competitorsBrand.mainAnalysis.brandInformation ? competitorsBrand.mainAnalysis.brandInformation.brandName : "Your Brand"}`,
                data: [scoring && scoring.competitorBrand && scoring.competitorBrand.productAnalysis && scoring.competitorBrand.productAnalysis.score, scoring && scoring.competitorBrand && scoring.competitorBrand.cxAnalysis && scoring.competitorBrand.cxAnalysis.score, scoring && scoring.competitorBrand && scoring.competitorBrand.commercializationAnalysis && scoring.competitorBrand.commercializationAnalysis.score, scoring && scoring.competitorBrand && scoring.competitorBrand.brandAttribute && scoring.competitorBrand.brandAttribute.score, scoring && scoring.competitorBrand && scoring.competitorBrand.marketingAnalysis && scoring.competitorBrand.marketingAnalysis.score],
                fill: true,
                backgroundColor: 'rgba(255, 99, 132, 0.2)',
                borderColor: 'rgb(255, 99, 132)',
                pointBackgroundColor: 'rgb(255, 99, 132)',
                pointBorderColor: '#fff',
                pointHoverBackgroundColor: '#fff',
                pointHoverBorderColor: 'rgb(255, 99, 132)'
            }
        ]
    };

    const options = {
        scale: {
            ticks: { beginAtZero: true }
        }
    };

    //temp

    // const setOurBrand = () => {

    // }
    // const setCompetitorsBrand = () => {

    // }
    // const setScoring = () => {

    // }


    const handleInputChangeOurBrand = (e) => {
        setOurBrand(prev => ({ ...prev, [e.target.name]: e.target.value }))
    }
    const handleInputChangeCompetitorBrand = (e) => {
        setCompetitorsBrand(prev => ({ ...prev, [e.target.name]: e.target.value }))
    }
    function validateAndFormatURL(inputURL) {
        // Remove protocols (http, https, etc.)
        let cleanedURL = inputURL.replace(/^(https?:|ftp:)?\/\/(www\.)?/, '');

        // Add 'www.' if not present
        if (!cleanedURL.startsWith('www.')) {
            cleanedURL = 'www.' + cleanedURL;
        }

        // Ensure the URL ends with a domain (e.g., ".com")


        return cleanedURL;
    }

    const startComparing = async () => {
        let instagramPostOurs = "";
        let instagramPostCompetitors = "";
        try {
            setLoading(true);

            const resultOwnBrand = await axios.post(process.env.REACT_APP_SERVER_URL + "/instagramanalysis", { username: ourBrand.instagramUrl })

            instagramPostOurs = resultOwnBrand.data.postData.map((hehe) => (
                {
                    caption: hehe.caption,
                    instaComments: hehe.instaComments,
                    instaLikes: hehe.instaLikes,
                    instaPlayCount: hehe.instaPlayCount,
                    instaReshareCount: hehe.instaReshareCount


                }
            ))

            setOurBrand((prev) => ({ ...prev, instagramResults: resultOwnBrand.data }))
        } catch {
            alert("Error");
            setLoading(false);

        }
        try {
            setLoading(true);


            const resultOwnBrand = await axios.post(process.env.REACT_APP_SERVER_URL + "/linkedinanalysis", { linkedinUrl: ourBrand.linkedinUrl })
            setOurBrand((prev) => ({ ...prev, linkedinResults: resultOwnBrand.data }))
        } catch {
            alert("Error");
            setLoading(false);

        }

        try {
            setLoading(true);


            const resultCompetitorBrand = await axios.post(process.env.REACT_APP_SERVER_URL + "/instagramanalysis", { username: competitorsBrand.instagramUrl })
            setCompetitorsBrand((prev) => ({ ...prev, instagramResults: resultCompetitorBrand.data }))
            instagramPostCompetitors = resultCompetitorBrand.data.postData.map((hehe) => (
                {
                    caption: hehe.caption,
                    instaComments: hehe.instaComments,
                    instaLikes: hehe.instaLikes,
                    instaPlayCount: hehe.instaPlayCount,
                    instaReshareCount: hehe.instaReshareCount


                }
            ))
        } catch {
            alert("Error");
            setLoading(false);

        }
        try {
            setLoading(true);


            const resultCompetitorBrand = await axios.post(process.env.REACT_APP_SERVER_URL + "/linkedinanalysis", { linkedinUrl: competitorsBrand.linkedinUrl })
            setCompetitorsBrand((prev) => ({ ...prev, linkedinResults: resultCompetitorBrand.data }))
            setLoading(false);

        } catch {
            alert("Error");
            setLoading(false);

        }
        console.log("ff", instagramPostOurs);
        console.log("gg", instagramPostCompetitors);
        handleGptRequest(JSON.stringify(instagramPostOurs), JSON.stringify(instagramPostCompetitors));


    }

    // POC

    const handleGptRequest = async (instagramPostOurs, instagramPostCompetitors) => {
        if (ourBrand.webUrl && competitorsBrand.webUrl) {
            try {
                setLoading(true)
                // setCompetitorBrand("")
                // const response = await axios.post(process.env.REACT_APP_SERVER_URL + "/newgpt", {
                //     domain: ourBrand.webUrl
                // })
                const response = await axios.post(process.env.REACT_APP_SERVER_URL + "/newgpt", {
                    domain: validateAndFormatURL(ourBrand.webUrl),
                    instagramData: instagramPostOurs
                })
                await handleGptRequestCompetitor(response.data, instagramPostCompetitors);
                // const response = await axios.post(process.env.REACT_APP_SERVER_URL + "/newgpt", {
                //     domain: url
                // })
                setOurBrand((prev) => ({ ...prev, mainAnalysis: response.data }))
                // setLoading(false)
                setLoading(false)

                try {
                    setLoading(true);

                    // setReviewsLoader(true)
                    const reviews = await axios.post(process.env.REACT_APP_SERVER_URL + "/getBrandsReviews",
                        {
                            domain: ourBrand.webUrl
                        }

                    )
                    if (reviews.data) {
                        if (!reviews.data.message) {
                            setOurBrand((prev) => ({ ...prev, reviews: reviews.data }))
                        }
                    }
                    // setReviewsLoader(false)
                    setLoading(false)
                    setDone(true);

                }
                catch (e) {
                    console.log("here in catch reviews");
                    console.log("Error", e);
                    // setReviewsLoader(false)
                    setLoading(false)
                }
            }
            catch (e) {
                console.log("Error", e);
                setLoading(false)
            }
            setLoading(false);

        }
        else {
            alert("Please Enter a Valid Url")
        }

    }
    const handleGptRequestCompetitor = async (ourBrandData, instagramPostCompetitors) => {
        try {
            setLoading(true)
            // const response = await axios.post(process.env.REACT_APP_SERVER_URL + "/newgpt", {
            //     domain: competitorsBrand.weburl
            // })
            console.log("broo");
            const response = await axios.post(process.env.REACT_APP_SERVER_URL + "/newgpt", {
                domain: validateAndFormatURL(competitorsBrand.webUrl),
                instagramData: instagramPostCompetitors
            })
            // const response = await axios.post(process.env.REACT_APP_SERVER_URL + "/newgpt", {
            //     domain: domainCompetitor
            // })
            setCompetitorsBrand((prev) => ({ ...prev, mainAnalysis: response.data }))
            setLoading(false)

            // setLoading(false)
            try {
                setLoading(true);

                // setReviewsLoaderCompetitors(true)
                // const reviews = await axios.post(process.env.REACT_APP_SERVER_URL + "/getBrandsReviews",
                //     {
                //         domain: competitorsBrand.weburl
                //     }

                // )
                const reviews = await axios.post(process.env.REACT_APP_SERVER_URL + "/getBrandsReviews",
                    {
                        domain: competitorsBrand.webUrl
                    }

                )
                if (reviews.data) {
                    if (!reviews.data.message) {
                        setCompetitorsBrand((prev) => ({ ...prev, reviews: reviews.data }))
                    }
                }
                // setReviewsLoaderCompetitors(false)
                setLoading(false)

            }
            catch (e) {
                console.log("here competitor brand's reviews");
                console.log("Error", e);
                // setReviewsLoaderCompetitors(false)
                setLoading(false)

            }
            try {
                setLoading(true);

                // setLoading(true)
                // const response = await axios.post(process.env.REACT_APP_SERVER_URL + "/newgptcompetitor", {
                //     domain: ourbrand,
                //     competitor: competitorBrand
                // })
                // const responseScore = await axios.post(process.env.REACT_APP_SERVER_URL + "/newgptcompetitor", {
                //     domain: ourbrand,
                //     competitor: response.data
                // })
                // const responseScore = await axios.post(process.env.REACT_APP_SERVER_URL + "/newgptcompetitor", {
                //     domain: ourBrand.mainAnalysis,
                //     competitor: response.data
                // })
                const responseScore = await axios.post(process.env.REACT_APP_SERVER_URL + "/newgptcompetitor", {
                    domain: ourBrandData,
                    competitor: response.data
                })
                setScoring(responseScore.data)
                // setLoading(false)
                setLoading(false)

            }
            catch (e) {
                // setLoading(false)
                setLoading(false)

            }
        }
        catch (e) {
            console.log("Error", e);
            setLoading(false)
        }
    }

    const handleDbSave = async () => {
        try {
            //fetching previous data first
            if (user) {
                // // console.log("Fetching Data from DB");
                const docRef = doc(firestoredb, "users", user.uid);
                const docSnap = await getDoc(docRef);

                if (docSnap.exists()) {
                    // // console.log("Document data gs:", docSnap.data());
                    if (docSnap.data().comparisionHistory) {

                        let comparisionHistory = docSnap.data().comparisionHistory;

                        await updateDoc(docRef, {
                            comparisionHistory: [
                                ...comparisionHistory,
                                {
                                    ourBrand: {
                                        ...ourBrand, reviews: {}
                                    },
                                    competitorsBrand: {
                                        ...competitorsBrand, reviews: {}
                                    },
                                    scoring
                                }
                            ],
                        });
                        console.log("Data Successfully save to Database");
                    }
                    else {
                        await updateDoc(docRef, {
                            comparisionHistory: [
                                {
                                    ourBrand: {
                                        ...ourBrand, reviews: {}
                                    },
                                    competitorsBrand: {
                                        ...competitorsBrand, reviews: {}
                                    },
                                    scoring
                                }
                            ],
                        });
                        console.log("Data Successfully save to Database");
                    }
                }
            }
        }
        catch (e) {
            console.log("Error", e);
            console.log("Error while saving to Database");
        }
    }
    useEffect(() => {
        console.log("Our Brand", ourBrand);
        console.log("Competitor Brand", competitorsBrand);
        console.log("Scoring", scoring);
    }, [ourBrand, competitorsBrand])

    useEffect(() => {
        if (done) {

            handleDbSave();
        }
    }, [done])

    useEffect(() => {
        if (props.previousData) {
            setOurBrand(props.previousData.ourBrand);
            setCompetitorsBrand(props.previousData.competitorBrand);
            setScoring(props.previousData.scoring);
            setShowComparing(true);
        }
    }, [])

    const getPageMarginsF = () => {
        return `@page :first { margin: ${"0px"} ${"0px"} ${"10px"} ${"0px"} !important; }`;
    };
    const getPageMargins = () => {
        return `@page { margin: ${"30px"} ${"30px"} ${"30px"} ${"30px"} !important; }`;
    };
    const getPageMarginst = () => {
        return `table { page-break-inside: avoid; }`;
    };

    return (
        <div className=''>{!showComparing ? (
            <div className='BrandComparison-container customScroller-transparent'>
                <h3>Compare your brand</h3>
                <div className='BrandComparison-socialMediaStats-container'>
                    <div className='BrandComparison-socialMediaStats-box'>
                        <h5>Your brand</h5>
                        <div className='brand_inputs-box'>
                            <h6>Website URL</h6>
                            <input className='input-theme' type='text' placeholder='Your brand' name="webUrl" onChange={handleInputChangeOurBrand} />
                        </div>
                        <div className='brand_inputs-box'>
                            <h6>Social Media Links</h6>
                            {/* <input className='input-theme' type='text' placeholder='Facebook URL' name="facebookUrl" onChange={handleInputChangeOurBrand} /> */}
                            <input className='input-theme' type='text' placeholder='Instagram URL' name="instagramUrl" onChange={handleInputChangeOurBrand} />
                            {/* <input className='input-theme' type='text' placeholder='X URL' name="xUrl" onChange={handleInputChangeOurBrand} /> */}
                            {/* <input className='input-theme' type='text' placeholder='Linkedin URL' name="linkedinUrl" onChange={handleInputChangeOurBrand} /> */}
                        </div>
                    </div>
                    <div className='BrandComparison-socialMediaStats-box'>
                        <h5>Brand you want to compare</h5>
                        <div className='brand_inputs-box'>
                            <h6>Website URL</h6>
                            <input className='input-theme' type='text' placeholder='Competitor brand' name="webUrl" onChange={handleInputChangeCompetitorBrand} />
                        </div>
                        <div className='brand_inputs-box'>
                            <h6>Social Media Links</h6>
                            {/* <input className='input-theme' type='text' placeholder='Facebook URL' name="facebookUrl" onChange={handleInputChangeCompetitorBrand} /> */}
                            <input className='input-theme' type='text' placeholder='Instagram URL' name="instagramUrl" onChange={handleInputChangeCompetitorBrand} />
                            {/* <input className='input-theme' type='text' placeholder='X URL' name="xUrl" onChange={handleInputChangeCompetitorBrand} /> */}
                            {/* <input className='input-theme' type='text' placeholder='Linkedin URL' name="linkedinUrl" onChange={handleInputChangeCompetitorBrand} /> */}
                        </div>
                        <button className='dark-theme-btn' onClick={() => {
                            startComparing();
                            handleShowComparing()
                        }}>Start Comparing</button>
                    </div>
                </div>
            </div >
        ) : (
            <div className='ComparisonReport-container customScroller-transparent'>
                <div className='ComparisonReport-inner-container'>
                    <h3 style={{ display: "flex", alignItems: "center" }}>Comparison Report
                        <button style={{ backgroundColor: "#93393C", color: "white", marginLeft: "20px", borderRadius: "5px", padding: "5px", fontSize: "16px" }} onClick={handlePrint}>Save PDF</button>
                    </h3>
                    <div className='ComparisonReport-leftRight-main' ref={reportRef}>
                        <style>{getPageMargins()}</style>
                        <style>{getPageMarginst()}</style>
                        <div className='ComparisonReport-left-main'>
                            <h5>{ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation ? ourBrand.mainAnalysis.brandInformation.brandName : "Your Brand"}</h5>
                            <h6>{ourBrand.mainAnalysis && ourBrand.webUrl ? ourBrand.webUrl : "Website"}</h6>
                            <p>Following are the thorough analysis of {ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation ? ourBrand.mainAnalysis.brandInformation.brandName : "Your Brand"}</p>
                            <div className='ComparisonReport-rank-container'>
                                <div className='ComparisonReport-rankleft-box'>
                                    <div>
                                        <h6>Brand Health</h6>
                                        <span><h4>{ourBrand.mainAnalysis && ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation && ourBrand.mainAnalysis.brandInformation.companyAnalysis ? ourBrand.mainAnalysis.brandInformation.companyAnalysis.brandHealth : "Brand Health"}</h4></span>
                                    </div>
                                    <div>
                                        <h6>Estimated Customers</h6>
                                        <span><h4>{ourBrand.mainAnalysis && ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation && ourBrand.mainAnalysis.brandInformation.companyAnalysis ? ourBrand.mainAnalysis.brandInformation.companyAnalysis.estimatedCustomer : "Estimated Customer"}</h4></span>
                                    </div>
                                </div>
                                <div className='ComparisonReport-rankright-box'>
                                    <div className='userCardDetails-ComparisonReport'>
                                        <div className='userCardDetails-head-left'>
                                            {/* <img src={nvidiaImg} alt='' /> */}
                                            <h6>{ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation ? ourBrand.mainAnalysis.brandInformation.brandName : "Your Brand"}</h6>
                                        </div>
                                        <div className='userCardDetails-head-right'>
                                            <p>GROWTH</p>
                                            <span>{ourBrand.mainAnalysis && ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation && ourBrand.mainAnalysis.brandInformation.companyAnalysis ? ourBrand.mainAnalysis.brandInformation.companyAnalysis.growthTrend
                                                : "Trend"}</span>
                                        </div>
                                    </div>
                                    <div className='userCardDetails-ComparisonReport userCardDetails-ComparisonReport2'>
                                        <div className='userCardDetails-visitors-left'>
                                            <h5>Percentage</h5>
                                            <p>{ourBrand.mainAnalysis && ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation && ourBrand.mainAnalysis.brandInformation.companyAnalysis ? ourBrand.mainAnalysis.brandInformation.companyAnalysis.growthPercentageOfBrand : "%"}</p>
                                        </div>
                                        <div className='userCardDetails-graph-left'>
                                            <CardChart />
                                        </div>
                                    </div>
                                    {/* <img src={cardImg} alt='' /> */}
                                </div>
                            </div>

                            {/* <div className='ComparisonReport-performance-container '>
                                <h4>Facebook Analytics</h4>
                                <div className='performance-line-container performance-line-containerblue'>
                                    <div className='percentageLine' style={{ width: "92%" }}></div>
                                    <div className='percentageDot' style={{ left: "90%" }}>•</div>
                                </div>
                                <h5 className='performance-blue'>Performance 37%</h5>
                                <p>Aliquam gravida sapien leo, eget scelerisque magna convallis a. Phasellus dapibus ligula non.</p>
                            </div> */}

                            {/* <div className="ComparisonReport-performance-container">
                                <h4>Instagram Analytics</h4>
                                <div className="performance-line-container performance-line-containerpink">
                                    <div
                                        className="percentageLine"
                                        style={{
                                            width:
                                                ourBrand.instagramResults &&
                                                Math.round(ourBrand.instagramResults.averageScore) +
                                                "%",
                                        }}
                                    ></div>
                                    <div
                                        className="percentageDot"
                                        style={{
                                            left:
                                                ourBrand.instagramResults &&
                                                Math.round(ourBrand.instagramResults.averageScore) -
                                                2 +
                                                "%",
                                        }}
                                    >
                                        •
                                    </div>
                                </div>
                                <h5 className="performance-pink">
                                    Performance{" "}
                                    {ourBrand.instagramResults &&
                                        Math.round(ourBrand.instagramResults.averageScore) + "%"}
                                </h5>
                                <p>
                                    After analyzing different posts and their engagement ratio,
                                    we have calculated this{" "}
                                    <span style={{ color: "#CD486B" }}>Instagram</span> score.
                                </p>
                            </div> */}

                            {/* <div className='ComparisonReport-performance-container'>
                                <h4>X Analytics</h4>
                                <div className='performance-line-container performance-line-containerblack'>
                                    <div className='percentageLine'></div>

                                </div>
                                <h5 className='performance-black'>Performance 63%</h5>
                                <p>Aliquam gravida sapien leo, eget scelerisque magna convallis a. Phasellus dapibus ligula non.</p>
                            </div> */}

                            {/* <div className="ComparisonReport-performance-container">
                                <h4>Linkedin Analytics</h4>
                                <div className="performance-line-container performance-line-containerDarkBlue">
                                    <div
                                        className="percentageLine"
                                        style={{
                                            width:
                                                ourBrand.linkedinResults &&
                                                Math.round(ourBrand.linkedinResults.averageScore) +
                                                "%",
                                        }}
                                    ></div>
                                    <div
                                        className="percentageDot"
                                        style={{
                                            left:
                                                ourBrand.instagramResults &&
                                                Math.round(ourBrand.instagramResults.averageScore) -
                                                2 +
                                                "%",
                                        }}
                                    >
                                        •
                                    </div>
                                </div>
                                <h5 className="performance-DarkBlue">
                                    Performance{" "}
                                    {ourBrand.linkedinResults &&
                                        Math.round(ourBrand.linkedinResults.averageScore) + "%"}
                                </h5>
                                <p>
                                    After analyzing different posts and their engagement ratio,
                                    we have calculated this{" "}
                                    <span style={{ color: "#0A66C2" }}>Linkedin</span> score.
                                </p>
                            </div> */}

                            <h5>Revenue</h5>
                            <p>{ourBrand.mainAnalysis && ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation && ourBrand.mainAnalysis.brandInformation.companyAnalysis ? ourBrand.mainAnalysis.brandInformation.companyAnalysis.estimatedRevenue : "%"}</p>

                            <h5>Recent Social Stats</h5>
                            <div className='dashboardMain-socialMediaStats-box'>
                                <h5>Instagram</h5>
                                <ul>
                                    <li>
                                        <span>Likes</span>
                                        <span>{ourBrand.instagramResults && ourBrand.instagramResults.postData && ourBrand.instagramResults.postData[0].instaLikes}</span>
                                    </li>
                                    <li>
                                        <span>Comments</span>
                                        <span>{ourBrand.instagramResults && ourBrand.instagramResults.postData && ourBrand.instagramResults.postData[0].instaLikes}</span>
                                    </li>
                                    <li>
                                        <span>Views</span>
                                        <span>{ourBrand.instagramResults && ourBrand.instagramResults.postData && ourBrand.instagramResults.postData[0].instaPlayCount}</span>
                                    </li>
                                    <li>
                                        <span>Share</span>
                                        <span>{ourBrand.instagramResults && ourBrand.instagramResults.postData && ourBrand.instagramResults.postData[0].instaReshareCount}</span>
                                    </li>
                                </ul>
                                <div className="keyProductFeatures liFlex" style={{ marginTop: "7px", color: "white" }}>
                                    <h5>Social Analytics</h5>

                                    <ul>
                                        <h6>Audience Engagement Analysis</h6>
                                        {ourBrand.mainAnalysis &&
                                            ourBrand.mainAnalysis.brandInformation &&
                                            ourBrand.mainAnalysis.brandInformation
                                                .socialAnalysis
                                            &&
                                            ourBrand.mainAnalysis.brandInformation
                                                .socialAnalysis
                                                .audienceEngagementAnalysis
                                            ? ourBrand.mainAnalysis.brandInformation.socialAnalysis
                                                .audienceEngagementAnalysis.map(
                                                    (feature) => (
                                                        <li>
                                                            <Icon
                                                                icon="solar:map-arrow-right-bold-duotone"
                                                                width="15"
                                                                height="15"
                                                            />
                                                            {feature}
                                                        </li>
                                                    )
                                                )
                                            : "Some Error Occured"}
                                    </ul>

                                    <ul style={{ marginTop: "7px" }}>
                                        <h6>Social Content Analysis</h6>
                                        {ourBrand.mainAnalysis &&
                                            ourBrand.mainAnalysis.brandInformation &&
                                            ourBrand.mainAnalysis.brandInformation
                                                .socialAnalysis
                                            &&
                                            ourBrand.mainAnalysis.brandInformation
                                                .socialAnalysis
                                                .contentAnalysis

                                            ? ourBrand.mainAnalysis.brandInformation.socialAnalysis
                                                .contentAnalysis
                                                .map(
                                                    (feature) => (
                                                        <li>
                                                            <Icon
                                                                icon="solar:map-arrow-right-bold-duotone"
                                                                width="15"
                                                                height="15"
                                                            />
                                                            {feature}
                                                        </li>
                                                    )
                                                )
                                            : "Some Error Occured"}
                                    </ul>

                                    <ul style={{ marginTop: "7px" }}>
                                        <h6>Social Content Frequency Analysis</h6>
                                        {ourBrand.mainAnalysis &&
                                            ourBrand.mainAnalysis.brandInformation &&
                                            ourBrand.mainAnalysis.brandInformation
                                                .socialAnalysis
                                            &&
                                            ourBrand.mainAnalysis.brandInformation
                                                .socialAnalysis
                                                .contentUploadingFrequencyAnalysis


                                            ? ourBrand.mainAnalysis.brandInformation.socialAnalysis
                                                .contentUploadingFrequencyAnalysis

                                                .map(
                                                    (feature) => (
                                                        <li>
                                                            <Icon
                                                                icon="solar:map-arrow-right-bold-duotone"
                                                                width="15"
                                                                height="15"
                                                            />
                                                            {feature}
                                                        </li>
                                                    )
                                                )
                                            : "Some Error Occured"}
                                    </ul>

                                    <ul style={{ marginTop: "7px" }}>
                                        <h6>Response Rate Analysis</h6>
                                        {ourBrand.mainAnalysis &&
                                            ourBrand.mainAnalysis.brandInformation &&
                                            ourBrand.mainAnalysis.brandInformation
                                                .socialAnalysis
                                            &&
                                            ourBrand.mainAnalysis.brandInformation
                                                .socialAnalysis
                                                .responseRate



                                            ? ourBrand.mainAnalysis.brandInformation.socialAnalysis
                                                .responseRate


                                                .map(
                                                    (feature) => (
                                                        <li>
                                                            <Icon
                                                                icon="solar:map-arrow-right-bold-duotone"
                                                                width="15"
                                                                height="15"
                                                            />
                                                            {feature}
                                                        </li>
                                                    )
                                                )
                                            : "Some Error Occured"}
                                    </ul>

                                </div>
                            </div>
                            {/* <div className='py-3'>
                                <h6>Total Revenue: <span>51k</span></h6>
                                <SimplePieChart />
                            </div> */}

                            {/* <h5>Summary</h5>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent venenatis sem enim, non tristique magna rutrum vel. Praesent at ante vitae nibh malesuada bibendum eu id dolor. Integer scelerisque odio quis turpis laoreet, ac congue velit sodales. Phasellus pharetra ac leo eu gravida. </p> */}

                            <h5 className='pt-4 pb-3'>Product Feature Analysis</h5>
                            <div className="productAnalysisContent">
                                <div className="keyProductFeatures">
                                    <h5>Key Product Features</h5>
                                    <ul>
                                        {ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation && ourBrand.mainAnalysis.brandInformation.productFeaturesAnalysis && ourBrand.mainAnalysis.brandInformation.productFeaturesAnalysis.keyProductFeatures ?
                                            ourBrand.mainAnalysis.brandInformation.productFeaturesAnalysis.keyProductFeatures.map((feature) => (
                                                <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{feature}</li>
                                            ))
                                            :
                                            "Some Error Occured"}
                                    </ul>
                                </div>
                                <div className="keyProductFeatures">
                                    <h5>Interesting Product Differentiations</h5>
                                    <ul>
                                        {ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation && ourBrand.mainAnalysis.brandInformation.productFeaturesAnalysis && ourBrand.mainAnalysis.brandInformation.productFeaturesAnalysis.interestingProductDifferntiators ?
                                            ourBrand.mainAnalysis.brandInformation.productFeaturesAnalysis.interestingProductDifferntiators.map((differntiators) => (
                                                <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{differntiators}</li>
                                            ))
                                            :
                                            "Some Error Occured"}
                                    </ul>
                                </div>
                                <div className="keyProductFeatures">
                                    <h5>Quotes about Product Features</h5>
                                    <ul>
                                        {ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation && ourBrand.mainAnalysis.brandInformation.productFeaturesAnalysis && ourBrand.mainAnalysis.brandInformation.productFeaturesAnalysis.citedQuotes && ourBrand.mainAnalysis.brandInformation.productFeaturesAnalysis.citedQuotes.length > 0 ?
                                            ourBrand.mainAnalysis.brandInformation.productFeaturesAnalysis.citedQuotes.map((citedQuote) => (
                                                <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{citedQuote && citedQuote.quote ? citedQuote.quote : "Error Fecthing Quotes"}<em>{citedQuote && citedQuote.quote && citedQuote.source ? " - " : ""}{citedQuote && citedQuote.source ? citedQuote.source : "Error Fecthing Quotes"}</em></li>
                                            ))
                                            :
                                            "Not enough online presence found"}
                                    </ul>
                                </div>
                                <div className="keyProductFeatures scoring">
                                    <h5>Scoring</h5>
                                    <h6>{scoring && scoring.ourBrand && scoring.ourBrand.productAnalysis && scoring.ourBrand.productAnalysis.score + " out of 100"}</h6>
                                    <div className='px-4'>
                                        <div className='performance-line-container performance-line-containerDarkBlue'>
                                            <div className='percentageLine' style={{ width: `${scoring && scoring.ourBrand && scoring.ourBrand.productAnalysis && scoring.ourBrand.productAnalysis.score}%` }}></div>
                                        </div>
                                    </div>
                                    <p>{scoring && scoring.ourBrand && scoring.ourBrand.productAnalysis && scoring.ourBrand.productAnalysis.reason}</p>
                                </div>
                            </div>
                            <h5 className='pt-4'>Commercialization Analysis</h5>
                            <div className="productAnalysisContent">
                                <div className="keyProductFeatures">
                                    <h5>Commercialization Strategies</h5>
                                    <ul>
                                        {ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation && ourBrand.mainAnalysis.brandInformation.commercializationAnalysis && ourBrand.mainAnalysis.brandInformation.commercializationAnalysis.keyCommercializationStrategies ?
                                            ourBrand.mainAnalysis.brandInformation.commercializationAnalysis.keyCommercializationStrategies.map((strategy) => (
                                                <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{strategy}</li>
                                            ))
                                            :
                                            "Some Error Occured"}
                                    </ul>
                                </div>
                                <div className="keyProductFeatures">
                                    <h5>Interesting Commercialization Differentiations</h5>
                                    <ul>
                                        {ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation && ourBrand.mainAnalysis.brandInformation.commercializationAnalysis && ourBrand.mainAnalysis.brandInformation.commercializationAnalysis.interestingCommercializationDifferntiators ?
                                            ourBrand.mainAnalysis.brandInformation.commercializationAnalysis.interestingCommercializationDifferntiators.map((differntiators) => (
                                                <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{differntiators}</li>
                                            ))
                                            :
                                            "Some Error Occured"}
                                    </ul>
                                </div>
                                <div className="keyProductFeatures">
                                    <h5>Quotes about Commercialization Strategies</h5>
                                    <ul>
                                        {ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation && ourBrand.mainAnalysis.brandInformation.commercializationAnalysis && ourBrand.mainAnalysis.brandInformation.commercializationAnalysis.citedQuotes && ourBrand.mainAnalysis.brandInformation.commercializationAnalysis.citedQuotes.length > 0 ?
                                            ourBrand.mainAnalysis.brandInformation.commercializationAnalysis.citedQuotes.map((citedQuote) => (
                                                <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{citedQuote && citedQuote.quote ? citedQuote.quote : "Error Fecthing Quotes"}<em>{citedQuote && citedQuote.quote && citedQuote.source ? " - " : ""}{citedQuote && citedQuote.source ? citedQuote.source : "Error Fecthing Quotes"}</em></li>
                                            ))
                                            :
                                            "Not enough online presence found"}
                                    </ul>
                                </div>
                                <div className="keyProductFeatures scoring">
                                    <h5>Scoring</h5>
                                    <h6>{scoring && scoring.ourBrand && scoring.ourBrand.commercializationAnalysis && scoring.ourBrand.commercializationAnalysis.score + " out of 100"}</h6>
                                    <div className='px-4'> <div className='performance-line-container performance-line-containerDarkBlue'> <div className='percentageLine' style={{ width: `${scoring && scoring.ourBrand && scoring.ourBrand.commercializationAnalysis && scoring.ourBrand.commercializationAnalysis.score}%` }}></div> </div> </div>
                                    <p>{scoring && scoring.ourBrand && scoring.ourBrand.commercializationAnalysis && scoring.ourBrand.commercializationAnalysis.reason}</p>

                                </div>
                            </div>
                            <h5 className='pt-4'>Customer Experience (CX) Analysis</h5>
                            <div className="productAnalysisContent">
                                <div className="keyProductFeatures">
                                    <h5>Key CX Strategies</h5>
                                    <ul>
                                        {ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation && ourBrand.mainAnalysis.brandInformation.customerExperienceAnalysis && ourBrand.mainAnalysis.brandInformation.customerExperienceAnalysis.keyCxStrategies ?
                                            ourBrand.mainAnalysis.brandInformation.customerExperienceAnalysis.keyCxStrategies.map((strategy) => (
                                                <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{strategy}</li>
                                            ))
                                            :
                                            "Some Error Occured"}
                                    </ul>
                                </div>
                                <div className="keyProductFeatures">
                                    <h5>Interesting CX Differentiations</h5>
                                    <ul>
                                        {ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation && ourBrand.mainAnalysis.brandInformation.customerExperienceAnalysis && ourBrand.mainAnalysis.brandInformation.customerExperienceAnalysis.interestingCxDifferntiators ?
                                            ourBrand.mainAnalysis.brandInformation.customerExperienceAnalysis.interestingCxDifferntiators.map((differntiators) => (
                                                <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{differntiators}</li>
                                            ))
                                            :
                                            "Some Error Occured"}
                                    </ul>
                                </div>
                                <div className="keyProductFeatures">
                                    <h5>Quotes about Customer Experience</h5>
                                    <ul>
                                        {ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation && ourBrand.mainAnalysis.brandInformation.customerExperienceAnalysis && ourBrand.mainAnalysis.brandInformation.customerExperienceAnalysis.citedQuotes && ourBrand.mainAnalysis.brandInformation.customerExperienceAnalysis.citedQuotes.length > 0 ?
                                            ourBrand.mainAnalysis.brandInformation.customerExperienceAnalysis.citedQuotes.map((citedQuote) => (
                                                <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{citedQuote && citedQuote.quote ? citedQuote.quote : "Error Fecthing Quotes"}<em>{citedQuote && citedQuote.quote && citedQuote.source ? " - " : ""}{citedQuote && citedQuote.source ? citedQuote.source : "Error Fecthing Quotes"}</em></li>
                                            ))
                                            :
                                            "Not enough online presence found"}
                                    </ul>
                                </div>
                                <div className="keyProductFeatures scoring">
                                    <h5>Scoring</h5>
                                    <h6>{scoring && scoring.ourBrand && scoring.ourBrand.cxAnalysis && scoring.ourBrand.cxAnalysis.score + " out of 100"}</h6>
                                    <div className='px-4'> <div className='performance-line-container performance-line-containerDarkBlue'> <div className='percentageLine' style={{ width: `${scoring && scoring.ourBrand && scoring.ourBrand.cxAnalysis && scoring.ourBrand.cxAnalysis.score}%` }}></div> </div> </div>
                                    <p>{scoring && scoring.ourBrand && scoring.ourBrand.cxAnalysis && scoring.ourBrand.cxAnalysis.reason}</p>

                                </div>
                            </div>
                            <h5 className='pt-4'>Brand Attributes Analysis</h5>
                            <div className="productAnalysisContent">
                                <div className="keyProductFeatures">
                                    <h5>Key Brand Attributes</h5>
                                    <ul>
                                        {ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation && ourBrand.mainAnalysis.brandInformation.brandAttributesAnalysis && ourBrand.mainAnalysis.brandInformation.brandAttributesAnalysis.keyBrandAttributes ?
                                            ourBrand.mainAnalysis.brandInformation.brandAttributesAnalysis.keyBrandAttributes.map((attribute) => (
                                                <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{attribute}</li>
                                            ))
                                            :
                                            "Some Error Occured"}
                                    </ul>
                                </div>
                                <div className="keyProductFeatures">
                                    <h5>Interesting Brand Differentiations</h5>
                                    <ul>
                                        {ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation && ourBrand.mainAnalysis.brandInformation.brandAttributesAnalysis && ourBrand.mainAnalysis.brandInformation.brandAttributesAnalysis.interestingBrandAttributesDifferntiators ?
                                            ourBrand.mainAnalysis.brandInformation.brandAttributesAnalysis.interestingBrandAttributesDifferntiators.map((differntiators) => (
                                                <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{differntiators}</li>
                                            ))
                                            :
                                            "Some Error Occured"}
                                    </ul>
                                </div>
                                <div className="keyProductFeatures">
                                    <h5>Quotes about Brand Attributes</h5>
                                    <ul>
                                        {ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation && ourBrand.mainAnalysis.brandInformation.brandAttributesAnalysis && ourBrand.mainAnalysis.brandInformation.brandAttributesAnalysis.citedQuotes && ourBrand.mainAnalysis.brandInformation.brandAttributesAnalysis.citedQuotes.length > 0 ?
                                            ourBrand.mainAnalysis.brandInformation.brandAttributesAnalysis.citedQuotes.map((citedQuote) => (
                                                <li><Icon icon="solar:map-arrow-right-bold-duotone" width="40" height="40" />{citedQuote && citedQuote.quote ? citedQuote.quote : "Error Fecthing Quotes"}<em>{citedQuote && citedQuote.quote && citedQuote.source ? " - " : ""}{citedQuote && citedQuote.source ? citedQuote.source : "Error Fecthing Quotes"}</em></li>
                                            ))
                                            :
                                            "Not enough online presence found"}
                                    </ul>
                                </div>
                                <div className="keyProductFeatures scoring">
                                    <h5>Scoring</h5>
                                    <h6>{scoring && scoring.ourBrand && scoring.ourBrand.brandAttribute && scoring.ourBrand.brandAttribute.score + " out of 100"}</h6>
                                    <div className='px-4'> <div className='performance-line-container performance-line-containerDarkBlue'> <div className='percentageLine' style={{ width: `${scoring && scoring.ourBrand && scoring.ourBrand.brandAttribute && scoring.ourBrand.brandAttribute.score}%` }}></div> </div> </div>
                                    <p>{scoring && scoring.ourBrand && scoring.ourBrand.brandAttribute && scoring.ourBrand.brandAttribute.reason}</p>

                                </div>
                            </div>
                            <h5 className='pt-4'>Marketing Analysis</h5>
                            <div className="productAnalysisContent">
                                <div className="keyProductFeatures">
                                    <h5>Key Marketing Strategies</h5>
                                    <ul>
                                        {ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation && ourBrand.mainAnalysis.brandInformation.marketingAnalysis && ourBrand.mainAnalysis.brandInformation.marketingAnalysis.keyMarketingStrategies ?
                                            ourBrand.mainAnalysis.brandInformation.marketingAnalysis.keyMarketingStrategies.map((strategy) => (
                                                <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{strategy}</li>
                                            ))
                                            :
                                            "Some Error Occured"}
                                    </ul>
                                </div>
                                <div className="keyProductFeatures">
                                    <h5>Interesting Marketing Differentiations</h5>
                                    <ul>
                                        {ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation && ourBrand.mainAnalysis.brandInformation.marketingAnalysis && ourBrand.mainAnalysis.brandInformation.marketingAnalysis.interestingMarketingStrategiesDifferntiators ?
                                            ourBrand.mainAnalysis.brandInformation.marketingAnalysis.interestingMarketingStrategiesDifferntiators.map((differntiators) => (
                                                <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{differntiators}</li>
                                            ))
                                            :
                                            "Some Error Occured"}
                                    </ul>
                                </div>
                                <div className="keyProductFeatures">
                                    <h5>Quotes about Marketing Strategies</h5>
                                    <ul>
                                        {ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation && ourBrand.mainAnalysis.brandInformation.marketingAnalysis && ourBrand.mainAnalysis.brandInformation.marketingAnalysis.citedQuotes && ourBrand.mainAnalysis.brandInformation.marketingAnalysis.citedQuotes.length > 0 ?
                                            ourBrand.mainAnalysis.brandInformation.marketingAnalysis.citedQuotes.map((citedQuote) => (
                                                <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{citedQuote && citedQuote.quote ? citedQuote.quote : "Error Fecthing Quotes"}<em>{citedQuote && citedQuote.quote && citedQuote.source ? " - " : ""}{citedQuote && citedQuote.source ? citedQuote.source : "Error Fecthing Quotes"}</em></li>
                                            ))
                                            :
                                            "Not enough online presence found"}
                                    </ul>
                                </div>
                                <div className="keyProductFeatures scoring">
                                    <h5>Scoring</h5>
                                    <h6>{scoring && scoring.ourBrand && scoring.ourBrand.marketingAnalysis && scoring.ourBrand.marketingAnalysis.score + " out of 100"}</h6>
                                    <div className='px-4'> <div className='performance-line-container performance-line-containerDarkBlue'> <div className='percentageLine' style={{ width: `${scoring && scoring.ourBrand && scoring.ourBrand.marketingAnalysis && scoring.ourBrand.marketingAnalysis.score}%` }}></div> </div> </div>
                                    <p>{scoring && scoring.ourBrand && scoring.ourBrand.marketingAnalysis && scoring.ourBrand.marketingAnalysis.reason}</p>

                                </div>
                            </div>
                            <h5 className='pt-4'>Scoring Visualization</h5>

                            <div className="productAnalysisContent" style={{ backgroundColor: "#fff" }}>
                                <div className="keyProductFeatures">
                                    <Radar data={dataOurBrand} options={options} />

                                </div>
                            </div>

                            <h5 className='pt-4'>Strengths</h5>
                            <div className="productAnalysisContent productAnalysisContent-Strengths">
                                <div className="keyProductFeatures keyProductFeatures-Strengths">
                                    <ul>
                                        {ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation && ourBrand.mainAnalysis.brandInformation.strengths ? ourBrand.mainAnalysis.brandInformation.strengths.map((strength) => (
                                            <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{strength}</li>
                                        ))
                                            :
                                            "Some Error Occured"}
                                    </ul>
                                </div>

                            </div>
                            <h5 className='pt-4'>Weaknesses</h5>
                            <div className="productAnalysisContent productAnalysisContent-Weaknesses">
                                <div className="keyProductFeatures">
                                    <ul>
                                        {ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation && ourBrand.mainAnalysis.brandInformation.weaknesses ? ourBrand.mainAnalysis.brandInformation.weaknesses.map((weakness) => (
                                            <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{weakness}</li>
                                        ))
                                            :
                                            "Some Error Occured"}
                                    </ul>
                                </div>

                            </div>
                            <h5 className='pt-4'>Recommendation</h5>
                            <div className="productAnalysisContent productAnalysisContent-Recommendation">
                                <div className="keyProductFeatures">
                                    <ul>
                                        {ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation && ourBrand.mainAnalysis.brandInformation.recommendation ? ourBrand.mainAnalysis.brandInformation.recommendation.map((recommendation) => (
                                            <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{recommendation}</li>
                                        ))
                                            :
                                            "Some Error Occured"}
                                    </ul>
                                </div>

                            </div>
                            {/* <h5 className='pt-4'>Digital Presence</h5>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent venenatis sem enim, non tristique magna rutrum vel.</p> */}
                        </div>

                        <div className="ComparisonReport-right-main">
                            <h5>
                                {competitorsBrand.mainAnalysis &&
                                    competitorsBrand.mainAnalysis.brandInformation
                                    ? competitorsBrand.mainAnalysis.brandInformation.brandName
                                    : "Your Brand"}
                            </h5>
                            <h6>
                                {competitorsBrand.mainAnalysis && competitorsBrand.webUrl
                                    ? competitorsBrand.webUrl
                                    : "Website"}
                            </h6>
                            <p>
                                Following are the thorough analysis of{" "}
                                {competitorsBrand.mainAnalysis &&
                                    competitorsBrand.mainAnalysis.brandInformation
                                    ? competitorsBrand.mainAnalysis.brandInformation.brandName
                                    : "Your Brand"}
                            </p>

                            <div className="ComparisonReport-rank-container">
                                <div className="ComparisonReport-rankleft-box">
                                    <div>
                                        <h6>Brand Health</h6>
                                        <span>
                                            <h4>
                                                {competitorsBrand.mainAnalysis &&
                                                    competitorsBrand.mainAnalysis &&
                                                    competitorsBrand.mainAnalysis.brandInformation &&
                                                    competitorsBrand.mainAnalysis.brandInformation
                                                        .companyAnalysis
                                                    ? competitorsBrand.mainAnalysis.brandInformation
                                                        .companyAnalysis.brandHealth
                                                    : "Brand Health"}
                                            </h4>
                                        </span>
                                    </div>
                                    <div>
                                        <h6>Estimated Customers</h6>
                                        <span>
                                            <h4>
                                                {competitorsBrand.mainAnalysis &&
                                                    competitorsBrand.mainAnalysis &&
                                                    competitorsBrand.mainAnalysis.brandInformation &&
                                                    competitorsBrand.mainAnalysis.brandInformation
                                                        .companyAnalysis
                                                    ? competitorsBrand.mainAnalysis.brandInformation
                                                        .companyAnalysis.estimatedCustomer
                                                    : "Estimated Customer"}
                                            </h4>
                                        </span>
                                    </div>
                                </div>
                                <div className="ComparisonReport-rankright-box">
                                    <div className="userCardDetails-ComparisonReport">
                                        <div className="userCardDetails-head-left">
                                            {/* <img src={nvidiaImg} alt='' /> */}
                                            <h6>
                                                {competitorsBrand.mainAnalysis &&
                                                    competitorsBrand.mainAnalysis.brandInformation
                                                    ? competitorsBrand.mainAnalysis.brandInformation
                                                        .brandName
                                                    : "Your Brand"}
                                            </h6>
                                        </div>
                                        <div className="userCardDetails-head-right">
                                            <p>GROWTH</p>
                                            <span>
                                                {competitorsBrand.mainAnalysis &&
                                                    competitorsBrand.mainAnalysis &&
                                                    competitorsBrand.mainAnalysis.brandInformation &&
                                                    competitorsBrand.mainAnalysis.brandInformation
                                                        .companyAnalysis
                                                    ? competitorsBrand.mainAnalysis.brandInformation
                                                        .companyAnalysis.growthTrend
                                                    : "Trend"}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="userCardDetails-ComparisonReport userCardDetails-ComparisonReport2">
                                        <div className="userCardDetails-visitors-left">
                                            <h5>Percentage</h5>
                                            <p>
                                                {competitorsBrand.mainAnalysis &&
                                                    competitorsBrand.mainAnalysis &&
                                                    competitorsBrand.mainAnalysis.brandInformation &&
                                                    competitorsBrand.mainAnalysis.brandInformation
                                                        .companyAnalysis
                                                    ? competitorsBrand.mainAnalysis.brandInformation
                                                        .companyAnalysis.growthPercentageOfBrand
                                                    : "%"}
                                            </p>
                                        </div>
                                        <div className="userCardDetails-graph-left">
                                            <CardChart />
                                        </div>
                                    </div>
                                    {/* <img src={cardImg} alt='' /> */}
                                </div>
                            </div>

                            {/* <div className='ComparisonReport-performance-container '>
                                <h4>Facebook Analytics</h4>
                                <div className='performance-line-container performance-line-containerblue'>
                                    <div className='percentageLine' style={{ width: "92%" }}></div>
                                    <div className='percentageDot' style={{ left: "90%" }}>•</div>
                                </div>
                                <h5 className='performance-blue'>Performance 37%</h5>
                                <p>Aliquam gravida sapien leo, eget scelerisque magna convallis a. Phasellus dapibus ligula non.</p>
                            </div> */}

                            {/* <div className="ComparisonReport-performance-container">
                                <h4>Instagram Analytics</h4>
                                <div className="performance-line-container performance-line-containerpink">
                                    <div
                                        className="percentageLine"
                                        style={{
                                            width:
                                                competitorsBrand.instagramResults &&
                                                Math.round(
                                                    competitorsBrand.instagramResults.averageScore
                                                ) + "%",
                                        }}
                                    ></div>
                                    <div
                                        className="percentageDot"
                                        style={{
                                            left:
                                                competitorsBrand.instagramResults &&
                                                Math.round(
                                                    competitorsBrand.instagramResults.averageScore
                                                ) -
                                                2 +
                                                "%",
                                        }}
                                    >
                                        •
                                    </div>
                                </div>
                                <h5 className="performance-pink">
                                    Performance{" "}
                                    {competitorsBrand.instagramResults &&
                                        Math.round(
                                            competitorsBrand.instagramResults.averageScore
                                        ) + "%"}
                                </h5>
                                <p>
                                    After analyzing different posts and their engagement ratio,
                                    we have calculated this{" "}
                                    <span style={{ color: "#CD486B" }}>Instagram</span> score.
                                </p>
                            </div> */}

                            {/* <div className='ComparisonReport-performance-container'>
                                <h4>X Analytics</h4>
                                <div className='performance-line-container performance-line-containerblack'>
                                    <div className='percentageLine'></div>

                                </div>
                                <h5 className='performance-black'>Performance 63%</h5>
                                <p>Aliquam gravida sapien leo, eget scelerisque magna convallis a. Phasellus dapibus ligula non.</p>
                            </div> */}

                            {/* <div className="ComparisonReport-performance-container">
                                <h4>Linkedin Analytics</h4>
                                <div className="performance-line-container performance-line-containerDarkBlue">
                                    <div
                                        className="percentageLine"
                                        style={{
                                            width:
                                                competitorsBrand.linkedinResults &&
                                                Math.round(
                                                    competitorsBrand.linkedinResults.averageScore
                                                ) + "%",
                                        }}
                                    ></div>
                                    <div
                                        className="percentageDot"
                                        style={{
                                            left:
                                                competitorsBrand.instagramResults &&
                                                Math.round(
                                                    competitorsBrand.instagramResults.averageScore
                                                ) -
                                                2 +
                                                "%",
                                        }}
                                    >
                                        •
                                    </div>
                                </div>
                                <h5 className="performance-DarkBlue">
                                    Performance{" "}
                                    {competitorsBrand.linkedinResults &&
                                        Math.round(
                                            competitorsBrand.linkedinResults.averageScore
                                        ) + "%"}
                                </h5>
                                <p>
                                    After analyzing different posts and their engagement ratio,
                                    we have calculated this{" "}
                                    <span style={{ color: "#0A66C2" }}>Linkedin</span> score.
                                </p>
                            </div> */}

                            <h5>Revenue</h5>
                            <p>{competitorsBrand.mainAnalysis && competitorsBrand.mainAnalysis && competitorsBrand.mainAnalysis.brandInformation && competitorsBrand.mainAnalysis.brandInformation.companyAnalysis ? competitorsBrand.mainAnalysis.brandInformation.companyAnalysis.estimatedRevenue : "%"}</p>
                            <h5>Recent Social Stats</h5>
                            <div className='dashboardMain-socialMediaStats-box'>
                                <h5>Instagram</h5>
                                <ul>
                                    <li>
                                        <span>Likes</span>
                                        <span>{competitorsBrand.instagramResults && competitorsBrand.instagramResults.postData && competitorsBrand.instagramResults.postData[0].instaLikes}</span>
                                    </li>
                                    <li>
                                        <span>Comments</span>
                                        <span>{competitorsBrand.instagramResults && competitorsBrand.instagramResults.postData && competitorsBrand.instagramResults.postData[0].instaLikes}</span>
                                    </li>
                                    <li>
                                        <span>Views</span>
                                        <span>{competitorsBrand.instagramResults && competitorsBrand.instagramResults.postData && competitorsBrand.instagramResults.postData[0].instaPlayCount}</span>
                                    </li>
                                    <li>
                                        <span>Share</span>
                                        <span>{competitorsBrand.instagramResults && competitorsBrand.instagramResults.postData && competitorsBrand.instagramResults.postData[0].instaReshareCount}</span>
                                    </li>
                                </ul>
                                <div className="keyProductFeatures liFlex" style={{ marginTop: "7px", color: "white" }}>
                                    <h5>Social Analytics</h5>

                                    <ul>
                                        <h6>Audience Engagement Analysis</h6>
                                        {competitorsBrand.mainAnalysis &&
                                            competitorsBrand.mainAnalysis.brandInformation &&
                                            competitorsBrand.mainAnalysis.brandInformation
                                                .socialAnalysis
                                            &&
                                            competitorsBrand.mainAnalysis.brandInformation
                                                .socialAnalysis
                                                .audienceEngagementAnalysis
                                            ? competitorsBrand.mainAnalysis.brandInformation.socialAnalysis
                                                .audienceEngagementAnalysis.map(
                                                    (feature) => (
                                                        <li>
                                                            <Icon
                                                                icon="solar:map-arrow-right-bold-duotone"
                                                                width="15"
                                                                height="15"
                                                            />
                                                            {feature}
                                                        </li>
                                                    )
                                                )
                                            : "Some Error Occured"}
                                    </ul>

                                    <ul style={{ marginTop: "7px" }}>
                                        <h6>Social Content Analysis</h6>
                                        {competitorsBrand.mainAnalysis &&
                                            competitorsBrand.mainAnalysis.brandInformation &&
                                            competitorsBrand.mainAnalysis.brandInformation
                                                .socialAnalysis
                                            &&
                                            competitorsBrand.mainAnalysis.brandInformation
                                                .socialAnalysis
                                                .contentAnalysis

                                            ? competitorsBrand.mainAnalysis.brandInformation.socialAnalysis
                                                .contentAnalysis
                                                .map(
                                                    (feature) => (
                                                        <li>
                                                            <Icon
                                                                icon="solar:map-arrow-right-bold-duotone"
                                                                width="15"
                                                                height="15"
                                                            />
                                                            {feature}
                                                        </li>
                                                    )
                                                )
                                            : "Some Error Occured"}
                                    </ul>

                                    <ul style={{ marginTop: "7px" }}>
                                        <h6>Social Content Frequency Analysis</h6>
                                        {competitorsBrand.mainAnalysis &&
                                            competitorsBrand.mainAnalysis.brandInformation &&
                                            competitorsBrand.mainAnalysis.brandInformation
                                                .socialAnalysis
                                            &&
                                            competitorsBrand.mainAnalysis.brandInformation
                                                .socialAnalysis
                                                .contentUploadingFrequencyAnalysis


                                            ? competitorsBrand.mainAnalysis.brandInformation.socialAnalysis
                                                .contentUploadingFrequencyAnalysis

                                                .map(
                                                    (feature) => (
                                                        <li>
                                                            <Icon
                                                                icon="solar:map-arrow-right-bold-duotone"
                                                                width="15"
                                                                height="15"
                                                            />
                                                            {feature}
                                                        </li>
                                                    )
                                                )
                                            : "Some Error Occured"}
                                    </ul>

                                    <ul style={{ marginTop: "7px" }}>
                                        <h6>Response Rate Analysis</h6>
                                        {competitorsBrand.mainAnalysis &&
                                            competitorsBrand.mainAnalysis.brandInformation &&
                                            competitorsBrand.mainAnalysis.brandInformation
                                                .socialAnalysis
                                            &&
                                            competitorsBrand.mainAnalysis.brandInformation
                                                .socialAnalysis
                                                .responseRate



                                            ? competitorsBrand.mainAnalysis.brandInformation.socialAnalysis
                                                .responseRate


                                                .map(
                                                    (feature) => (
                                                        <li>
                                                            <Icon
                                                                icon="solar:map-arrow-right-bold-duotone"
                                                                width="15"
                                                                height="15"
                                                            />
                                                            {feature}
                                                        </li>
                                                    )
                                                )
                                            : "Some Error Occured"}
                                    </ul>

                                </div>
                            </div>
                            {/* <div className='py-3'>
                                <h6>Total Revenue: <span>51k</span></h6>
                                <SimplePieChart />
                            </div> */}

                            {/* <h5>Summary</h5>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent venenatis sem enim, non tristique magna rutrum vel. Praesent at ante vitae nibh malesuada bibendum eu id dolor. Integer scelerisque odio quis turpis laoreet, ac congue velit sodales. Phasellus pharetra ac leo eu gravida. </p> */}

                            <h5 className='pt-4 pb-3'>Product Feature Analysis</h5>
                            <p>
                                <div className="productAnalysisContent">
                                    <div className="keyProductFeatures">
                                        <h5>Key Product Features</h5>
                                        <ul>
                                            {competitorsBrand.mainAnalysis && competitorsBrand.mainAnalysis.brandInformation && competitorsBrand.mainAnalysis.brandInformation.productFeaturesAnalysis && competitorsBrand.mainAnalysis.brandInformation.productFeaturesAnalysis.keyProductFeatures ?
                                                competitorsBrand.mainAnalysis.brandInformation.productFeaturesAnalysis.keyProductFeatures.map((feature) => (
                                                    <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />
                                                        {feature}</li>
                                                ))
                                                :
                                                "Some Error Occured"}
                                        </ul>
                                    </div>
                                    <div className="keyProductFeatures">
                                        <h5>Interesting Product Differentiations</h5>
                                        <ul>
                                            {competitorsBrand.mainAnalysis && competitorsBrand.mainAnalysis.brandInformation && competitorsBrand.mainAnalysis.brandInformation.productFeaturesAnalysis && competitorsBrand.mainAnalysis.brandInformation.productFeaturesAnalysis.interestingProductDifferntiators ?
                                                competitorsBrand.mainAnalysis.brandInformation.productFeaturesAnalysis.interestingProductDifferntiators.map((differntiators) => (
                                                    <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{differntiators}</li>
                                                ))
                                                :
                                                "Some Error Occured"}
                                        </ul>
                                    </div>
                                    <div className="keyProductFeatures">
                                        <h5>Quotes about Product Features</h5>
                                        <ul>
                                            {competitorsBrand.mainAnalysis && competitorsBrand.mainAnalysis.brandInformation && competitorsBrand.mainAnalysis.brandInformation.productFeaturesAnalysis && competitorsBrand.mainAnalysis.brandInformation.productFeaturesAnalysis.citedQuotes && competitorsBrand.mainAnalysis.brandInformation.productFeaturesAnalysis.citedQuotes.length > 0 ?
                                                competitorsBrand.mainAnalysis.brandInformation.productFeaturesAnalysis.citedQuotes.map((citedQuote) => (
                                                    <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{citedQuote && citedQuote.quote ? citedQuote.quote : "Error Fecthing Quotes"}<em>{citedQuote && citedQuote.quote && citedQuote.source ? " - " : ""}{citedQuote && citedQuote.source ? citedQuote.source : "Error Fecthing Quotes"}</em></li>
                                                ))
                                                :
                                                "Not enough online presence found"}
                                        </ul>
                                    </div>
                                    <div className="keyProductFeatures scoring">
                                        <h5>Scoring</h5>
                                        <h6>{scoring && scoring.competitorBrand && scoring.competitorBrand.productAnalysis && scoring.competitorBrand.productAnalysis.score + " out of 100"}</h6>
                                        <div className='px-4'> <div className='performance-line-container performance-line-containerDarkBlue'> <div className='percentageLine' style={{ width: `${scoring && scoring.competitorBrand && scoring.competitorBrand.productAnalysis && scoring.competitorBrand.productAnalysis.score}%` }}></div> </div> </div>
                                        <p>{scoring && scoring.competitorBrand && scoring.competitorBrand.productAnalysis && scoring.competitorBrand.productAnalysis.reason}</p>

                                    </div>
                                </div>
                            </p>
                            <h5 className='pt-4'>Commercialization Analysis</h5>
                            <p>
                                <div className="productAnalysisContent">
                                    <div className="keyProductFeatures">
                                        <h5>Commercialization Strategies</h5>
                                        <ul>
                                            {competitorsBrand.mainAnalysis && competitorsBrand.mainAnalysis.brandInformation && competitorsBrand.mainAnalysis.brandInformation.commercializationAnalysis && competitorsBrand.mainAnalysis.brandInformation.commercializationAnalysis.keyCommercializationStrategies ?
                                                competitorsBrand.mainAnalysis.brandInformation.commercializationAnalysis.keyCommercializationStrategies.map((strategy) => (
                                                    <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{strategy}</li>
                                                ))
                                                :
                                                "Some Error Occured"}
                                        </ul>
                                    </div>
                                    <div className="keyProductFeatures">
                                        <h5>Interesting Commercialization Differentiations</h5>
                                        <ul>
                                            {competitorsBrand.mainAnalysis && competitorsBrand.mainAnalysis.brandInformation && competitorsBrand.mainAnalysis.brandInformation.commercializationAnalysis && competitorsBrand.mainAnalysis.brandInformation.commercializationAnalysis.interestingCommercializationDifferntiators ?
                                                competitorsBrand.mainAnalysis.brandInformation.commercializationAnalysis.interestingCommercializationDifferntiators.map((differntiators) => (
                                                    <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{differntiators}</li>
                                                ))
                                                :
                                                "Some Error Occured"}
                                        </ul>
                                    </div>
                                    <div className="keyProductFeatures">
                                        <h5>Quotes about Commercialization Strategies</h5>
                                        <ul>
                                            {competitorsBrand.mainAnalysis && competitorsBrand.mainAnalysis.brandInformation && competitorsBrand.mainAnalysis.brandInformation.commercializationAnalysis && competitorsBrand.mainAnalysis.brandInformation.commercializationAnalysis.citedQuotes && competitorsBrand.mainAnalysis.brandInformation.commercializationAnalysis.citedQuotes.length > 0 ?
                                                competitorsBrand.mainAnalysis.brandInformation.commercializationAnalysis.citedQuotes.map((citedQuote) => (
                                                    <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{citedQuote && citedQuote.quote ? citedQuote.quote : "Error Fecthing Quotes"}<em>{citedQuote && citedQuote.quote && citedQuote.source ? " - " : ""}{citedQuote && citedQuote.source ? citedQuote.source : "Error Fecthing Quotes"}</em></li>
                                                ))
                                                :
                                                "Not enough online presence found"}
                                        </ul>
                                    </div>
                                    <div className="keyProductFeatures scoring">
                                        <h5>Scoring</h5>
                                        <h6>{scoring && scoring.competitorBrand && scoring.competitorBrand.commercializationAnalysis && scoring.competitorBrand.commercializationAnalysis.score + " out of 100"}</h6>
                                        <div className='px-4'> <div className='performance-line-container performance-line-containerDarkBlue'> <div className='percentageLine' style={{ width: `${scoring && scoring.competitorBrand && scoring.competitorBrand.commercializationAnalysis && scoring.competitorBrand.commercializationAnalysis.score}%` }}></div> </div> </div>
                                        <p>{scoring && scoring.competitorBrand && scoring.competitorBrand.commercializationAnalysis && scoring.competitorBrand.commercializationAnalysis.reason}</p>
                                    </div>
                                </div>
                            </p>
                            <h5 className='pt-4'>Customer Experience (CX) Analysis</h5>
                            <p>
                                <div className="productAnalysisContent">
                                    <div className="keyProductFeatures">
                                        <h5>Key CX Strategies</h5>
                                        <ul>
                                            {competitorsBrand.mainAnalysis && competitorsBrand.mainAnalysis.brandInformation && competitorsBrand.mainAnalysis.brandInformation.customerExperienceAnalysis && competitorsBrand.mainAnalysis.brandInformation.customerExperienceAnalysis.keyCxStrategies ?
                                                competitorsBrand.mainAnalysis.brandInformation.customerExperienceAnalysis.keyCxStrategies.map((strategy) => (
                                                    <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{strategy}</li>
                                                ))
                                                :
                                                "Some Error Occured"}
                                        </ul>
                                    </div>
                                    <div className="keyProductFeatures">
                                        <h5>Interesting CX Differentiations</h5>
                                        <ul>
                                            {competitorsBrand.mainAnalysis && competitorsBrand.mainAnalysis.brandInformation && competitorsBrand.mainAnalysis.brandInformation.customerExperienceAnalysis && competitorsBrand.mainAnalysis.brandInformation.customerExperienceAnalysis.interestingCxDifferntiators ?
                                                competitorsBrand.mainAnalysis.brandInformation.customerExperienceAnalysis.interestingCxDifferntiators.map((differntiators) => (
                                                    <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{differntiators}</li>
                                                ))
                                                :
                                                "Some Error Occured"}
                                        </ul>
                                    </div>
                                    <div className="keyProductFeatures">
                                        <h5>Quotes about Customer Experience</h5>
                                        <ul>
                                            {competitorsBrand.mainAnalysis && competitorsBrand.mainAnalysis.brandInformation && competitorsBrand.mainAnalysis.brandInformation.customerExperienceAnalysis && competitorsBrand.mainAnalysis.brandInformation.customerExperienceAnalysis.citedQuotes && competitorsBrand.mainAnalysis.brandInformation.customerExperienceAnalysis.citedQuotes.length > 0 ?
                                                competitorsBrand.mainAnalysis.brandInformation.customerExperienceAnalysis.citedQuotes.map((citedQuote) => (
                                                    <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{citedQuote && citedQuote.quote ? citedQuote.quote : "Error Fecthing Quotes"}<em>{citedQuote && citedQuote.quote && citedQuote.source ? " - " : ""}{citedQuote && citedQuote.source ? citedQuote.source : "Error Fecthing Quotes"}</em></li>
                                                ))
                                                :
                                                "Not enough online presence found"}
                                        </ul>
                                    </div>
                                    <div className="keyProductFeatures scoring">
                                        <h5>Scoring</h5>
                                        <h6>{scoring && scoring.competitorBrand && scoring.competitorBrand.cxAnalysis && scoring.competitorBrand.cxAnalysis.score + " out of 100"}</h6>
                                        <div className='px-4'> <div className='performance-line-container performance-line-containerDarkBlue'> <div className='percentageLine'></div> </div> </div>
                                        <p>{scoring && scoring.competitorBrand && scoring.competitorBrand.cxAnalysis && scoring.competitorBrand.cxAnalysis.reason}</p>
                                    </div>
                                </div>
                            </p>
                            <h5 className='pt-4'>Brand Attributes Analysis</h5>
                            <p>
                                <div className="productAnalysisContent">
                                    <div className="keyProductFeatures">
                                        <h5>Key Brand Attributes</h5>
                                        <ul>
                                            {competitorsBrand.mainAnalysis && competitorsBrand.mainAnalysis.brandInformation && competitorsBrand.mainAnalysis.brandInformation.brandAttributesAnalysis && competitorsBrand.mainAnalysis.brandInformation.brandAttributesAnalysis.keyBrandAttributes ?
                                                competitorsBrand.mainAnalysis.brandInformation.brandAttributesAnalysis.keyBrandAttributes.map((attribute) => (
                                                    <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{attribute}</li>
                                                ))
                                                :
                                                "Some Error Occured"}
                                        </ul>
                                    </div>
                                    <div className="keyProductFeatures">
                                        <h5>Interesting Brand Differentiations</h5>
                                        <ul>
                                            {competitorsBrand.mainAnalysis && competitorsBrand.mainAnalysis.brandInformation && competitorsBrand.mainAnalysis.brandInformation.brandAttributesAnalysis && competitorsBrand.mainAnalysis.brandInformation.brandAttributesAnalysis.interestingBrandAttributesDifferntiators ?
                                                competitorsBrand.mainAnalysis.brandInformation.brandAttributesAnalysis.interestingBrandAttributesDifferntiators.map((differntiators) => (
                                                    <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{differntiators}</li>
                                                ))
                                                :
                                                "Some Error Occured"}
                                        </ul>
                                    </div>
                                    <div className="keyProductFeatures">
                                        <h5>Quotes about Brand Attributes</h5>
                                        <ul>
                                            {competitorsBrand.mainAnalysis && competitorsBrand.mainAnalysis.brandInformation && competitorsBrand.mainAnalysis.brandInformation.brandAttributesAnalysis && competitorsBrand.mainAnalysis.brandInformation.brandAttributesAnalysis.citedQuotes && competitorsBrand.mainAnalysis.brandInformation.brandAttributesAnalysis.citedQuotes.length > 0 ?
                                                competitorsBrand.mainAnalysis.brandInformation.brandAttributesAnalysis.citedQuotes.map((citedQuote) => (
                                                    <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{citedQuote && citedQuote.quote ? citedQuote.quote : "Error Fecthing Quotes"}<em>{citedQuote && citedQuote.quote && citedQuote.source ? " - " : ""}{citedQuote && citedQuote.source ? citedQuote.source : "Error Fecthing Quotes"}</em></li>
                                                ))
                                                :
                                                "Not enough online presence found"}
                                        </ul>
                                    </div>
                                    <div className="keyProductFeatures scoring">
                                        <h5>Scoring</h5>
                                        <h6>{scoring && scoring.competitorBrand && scoring.competitorBrand.brandAttribute && scoring.competitorBrand.brandAttribute.score + " out of 100"}</h6>
                                        <div className='px-4'> <div className='performance-line-container performance-line-containerDarkBlue'> <div className='percentageLine' style={{ width: `${scoring && scoring.competitorBrand && scoring.competitorBrand.brandAttribute && scoring.competitorBrand.brandAttribute.score}%` }}></div> </div> </div>
                                        <p>{scoring && scoring.competitorBrand && scoring.competitorBrand.brandAttribute && scoring.competitorBrand.brandAttribute.reason}</p>
                                    </div>
                                </div>
                            </p>
                            <h5 className='pt-4'>Marketing Analysis</h5>
                            <p>
                                <div className="productAnalysisContent">
                                    <div className="keyProductFeatures">
                                        <h5>Key Marketing Strategies</h5>
                                        <ul>
                                            {competitorsBrand.mainAnalysis && competitorsBrand.mainAnalysis.brandInformation && competitorsBrand.mainAnalysis.brandInformation.marketingAnalysis && competitorsBrand.mainAnalysis.brandInformation.marketingAnalysis.keyMarketingStrategies ?
                                                competitorsBrand.mainAnalysis.brandInformation.marketingAnalysis.keyMarketingStrategies.map((strategy) => (
                                                    <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{strategy}</li>
                                                ))
                                                :
                                                "Some Error Occured"}
                                        </ul>
                                    </div>
                                    <div className="keyProductFeatures">
                                        <h5>Interesting Marketing Differentiations</h5>
                                        <ul>
                                            {competitorsBrand.mainAnalysis && competitorsBrand.mainAnalysis.brandInformation && competitorsBrand.mainAnalysis.brandInformation.marketingAnalysis && competitorsBrand.mainAnalysis.brandInformation.marketingAnalysis.interestingMarketingStrategiesDifferntiators ?
                                                competitorsBrand.mainAnalysis.brandInformation.marketingAnalysis.interestingMarketingStrategiesDifferntiators.map((differntiators) => (
                                                    <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{differntiators}</li>
                                                ))
                                                :
                                                "Some Error Occured"}
                                        </ul>
                                    </div>
                                    <div className="keyProductFeatures">
                                        <h5>Quotes about Marketing Strategies</h5>
                                        <ul>
                                            {competitorsBrand.mainAnalysis && competitorsBrand.mainAnalysis.brandInformation && competitorsBrand.mainAnalysis.brandInformation.marketingAnalysis && competitorsBrand.mainAnalysis.brandInformation.marketingAnalysis.citedQuotes && competitorsBrand.mainAnalysis.brandInformation.marketingAnalysis.citedQuotes.length > 0 ?
                                                competitorsBrand.mainAnalysis.brandInformation.marketingAnalysis.citedQuotes.map((citedQuote) => (
                                                    <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{citedQuote && citedQuote.quote ? citedQuote.quote : "Error Fecthing Quotes"}<em>{citedQuote && citedQuote.quote && citedQuote.source ? " - " : ""}{citedQuote && citedQuote.source ? citedQuote.source : "Error Fecthing Quotes"}</em></li>
                                                ))
                                                :
                                                "Not enough online presence found"}
                                        </ul>
                                    </div>
                                    <div className="keyProductFeatures scoring">
                                        <h5>Scoring</h5>
                                        <h6>{scoring && scoring.competitorBrand && scoring.competitorBrand.marketingAnalysis && scoring.competitorBrand.marketingAnalysis.score + " out of 100"}</h6>
                                        <div className='px-4'> <div className='performance-line-container performance-line-containerDarkBlue'> <div className='percentageLine' style={{ width: `${scoring && scoring.competitorBrand && scoring.competitorBrand.marketingAnalysis && scoring.competitorBrand.marketingAnalysis.score}%` }}></div> </div> </div>
                                        <p>{scoring && scoring.competitorBrand && scoring.competitorBrand.marketingAnalysis && scoring.competitorBrand.marketingAnalysis.reason}</p>
                                    </div>
                                </div>
                            </p>
                            <h5 className='pt-4'>Scoring Visualization</h5>

                            <div className="productAnalysisContent" style={{ backgroundColor: "#fff" }}>
                                <div className="keyProductFeatures">


                                    <Radar data={data} options={options} />
                                </div>

                            </div>
                            <h5 className='pt-4'>Strengths</h5>
                            <p>
                                <div className="productAnalysisContent productAnalysisContent-Strengths">
                                    <div className="keyProductFeatures keyProductFeatures-Strengths">
                                        <ul>
                                            {competitorsBrand.mainAnalysis && competitorsBrand.mainAnalysis.brandInformation && competitorsBrand.mainAnalysis.brandInformation.strengths ? competitorsBrand.mainAnalysis.brandInformation.strengths.map((strength) => (
                                                <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{strength}</li>
                                            ))
                                                :
                                                "Some Error Occured"}
                                        </ul>
                                    </div>

                                </div>
                            </p>
                            <h5 className='pt-4'>Weaknesses</h5>
                            <p>
                                <div className="productAnalysisContent productAnalysisContent-Weaknesses">
                                    <div className="keyProductFeatures keyProductFeatures-Weaknesses">
                                        <ul>
                                            {competitorsBrand.mainAnalysis && competitorsBrand.mainAnalysis.brandInformation && competitorsBrand.mainAnalysis.brandInformation.weaknesses ? competitorsBrand.mainAnalysis.brandInformation.weaknesses.map((weakness) => (
                                                <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{weakness}</li>
                                            ))
                                                :
                                                "Some Error Occured"}
                                        </ul>
                                    </div>

                                </div>
                            </p>
                            <h5 className='pt-4'>Recommendation</h5>
                            <p>
                                <div className="productAnalysisContent productAnalysisContent-Recommendation">
                                    <div className="keyProductFeatures keyProductFeatures-Recommendation">
                                        <ul>
                                            {competitorsBrand.mainAnalysis && competitorsBrand.mainAnalysis.brandInformation && competitorsBrand.mainAnalysis.brandInformation.recommendation ? competitorsBrand.mainAnalysis.brandInformation.recommendation.map((recommendation) => (
                                                <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{recommendation}</li>
                                            ))
                                                :
                                                "Some Error Occured"}
                                        </ul>
                                    </div>

                                </div>
                            </p>
                            {/* <h5 className='pt-4'>Digital Presence</h5>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent venenatis sem enim, non tristique magna rutrum vel.</p> */}
                        </div>

                    </div>
                    <div style={{ width: "50%", margin: "0 auto" }}>
                        <h5 className='pt-4 text-center fw-bold fs-3'>Combined Scoring Visualization</h5>

                        <div className="productAnalysisContent" style={{ backgroundColor: "#fff" }}>
                            <div className="keyProductFeatures">
                                <Radar data={dataCombined} options={options} />

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )

        }
            <Modal show={loading} centered>
                <Modal.Header>
                    <Modal.Title>Loading... Please wait</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <div class="lds-ringDashboard">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default BrandComparison;
